/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_ContentsInputs */

const en_gc_guides_contents = /** @type {(inputs: Gc_Guides_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In this guide`)
};

const zh_gc_guides_contents = /** @type {(inputs: Gc_Guides_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本篇内容`)
};

/**
* | output |
* | --- |
* | "In this guide" |
*
* @param {Gc_Guides_ContentsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_contents = /** @type {((inputs?: Gc_Guides_ContentsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_ContentsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_contents(inputs)
	return zh_gc_guides_contents(inputs)
});
export { gc_guides_contents as "gc.guides.contents" }